import React from "react";
import { Contact } from '../components/Contact';

const ContactPage = () => (
  <div className="pt-8">
    <Contact />
  </div>
);

export default ContactPage;